var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarBgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 184,
    viewBox: "0 0 343 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M155.934 -27.6861L214.404 -13.0409C224.926 -10.4056 235.923 -15.0353 241.392 -24.4021C251.671 -42.0097 277.735 -39.98 285.165 -20.9934L317.72 62.1995C321.366 71.5158 327.033 79.9071 334.314 86.7685L427.073 174.188C451.688 197.386 436.341 238.771 402.552 240.312L392.895 240.752C365.446 242.003 351.142 273.996 368.514 295.286C390.707 322.487 361.336 361.138 329.185 347.042L284.231 327.333C271.82 321.891 257.623 322.296 245.542 328.437L170.445 366.608C141.47 381.336 106.24 366.137 97.0717 334.954C93.2682 322.018 84.5835 311.068 72.8534 304.418L-22.3679 250.438C-53.8306 232.602 -37.2646 184.438 -1.4872 189.729C30.9606 194.528 49.435 153.85 24.47 132.574L14.5088 124.085C-15.3319 98.6546 10.5835 50.5008 48.2454 61.3989L94.3446 74.7385C124.663 83.5118 147.235 46.732 125.683 23.6729C104.534 1.04445 125.889 -35.2116 155.934 -27.6861Z",
    fill: "url(#paint0_linear_1355_7907)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_7907",
    x1: 349.765,
    y1: -42.2664,
    x2: 197.116,
    y2: 304.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED2F8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBgMobile);
export default __webpack_public_path__ + "static/media/sidebar-bg-mobile.8e16f8b306a786a1e454740fd16173e9.svg";
export { ForwardRef as ReactComponent };